import { DigitalEvent, trackDigitalEvent } from '@sparknz/tracking';

export function trackAccountSelection({
  numberOfAccount,
}: {
  numberOfAccount: number;
}) {
  trackDigitalEvent({
    event: 'modalWindow.view',
    w3cddl: {
      event: [
        {
          eventInfo: {
            eventName: 'Shop Account Selection Modal Window',
            eventAction: 'modalWindow.view',
          },
          attributes: {
            numberOfAccount,
          },
        },
      ],
    },
  } as unknown as DigitalEvent);
}
